import { create } from 'zustand';

interface User {
    id: string;
    email: string;
    phone?: string;
    name?: string;
}

interface UserState {
    user: User | null;
    phone: string;
    token: string | null;
    error: string;
    isValid: boolean;
    isAuthenticated: boolean;
    setUser: (user: User, token: string) => void;
    setPhone: (phone: string) => void
    setError: (error: string) => void
    logout: () => void;
    setValid: () => void;
    clearUser: () => void;
}

export const useUserStore = create<UserState>((set) => ({
    user: null,
    token: null,
    phone: "",
    error: "",
    isValid: false,
    isAuthenticated: false,

    setUser: (user, token) => {
        localStorage.setItem('auth_token', token);
        set({ user, token, isAuthenticated: true });
    },

    setValid: () => set({ isValid: true }),

    setPhone: (phone) => {
        set({ phone })
    },

    logout: () => {
        localStorage.removeItem('auth_token');
        set({ user: null, token: null, isAuthenticated: false });
    },

    setError: (error) => {
        set({ error })
    },

    clearUser: () => {
        set({ user: null, token: null, isAuthenticated: false });
    }
}));
